import { render } from "./legoTabLabel.vue?vue&type=template&id=0d8b945e"
import script from "./legoTabLabel.vue?vue&type=script&lang=js"
export * from "./legoTabLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/boxes/legoTabBox/legoTabLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d8b945e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d8b945e', __exports__)) {
    api.reload('0d8b945e', __exports__)
  }
  
  module.hot.accept("./legoTabLabel.vue?vue&type=template&id=0d8b945e", () => {
    api.rerender('0d8b945e', render)
  })

}


export default __exports__